import { Component, Input } from '@angular/core'
import { BasicAuthService } from '../../../../../services/basic-auth.service'
import { HelperService } from '../../../../../services/helper.service'

type RCA_TYPE = 'DEV' | 'RCA-F' | 'RCA-D' | 'RCA-O'

@Component({
    selector: 'app-rca-tag',
    templateUrl: './rca-tag.component.html',
    standalone: false
})
export class RcaTagComponent {
  @Input() type: RCA_TYPE
  @Input() tagName: string
  @Input() active?: string
  @Input() inactive?: string
  @Input() inactiveCount?: number

  constructor(private authService: BasicAuthService) {}

  public clickOnUrl(
    mainObject: string,
    url: string,
    type: RCA_TYPE,
    history: boolean = false,
  ): void {
    if (type === 'RCA-F' && this.authService.hasRCAFPackage()) {
      HelperService.clickOnRcaFaultUrl(mainObject, url, '_blank', history)
      return
    }
    if (type === 'RCA-D') {
      HelperService.clickOnRcaDemandUrl(mainObject, url, '_blank', history)
      return
    }
    if (type === 'RCA-O') {
      HelperService.clickOnRcaOverrideUrl(mainObject, url, '_blank', history)
      return
    }
    HelperService.clickOnUrl(url, '_blank')
  }

  public getBadgeClass(): string {
    if (this.type === 'RCA-D') {
      return 'badge badge-warning'
    }
    if (this.type === 'RCA-O') {
      return 'badge badge-info'
    }
    return 'badge badge-danger'
  }
}
